<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="col-sm-12">
      <div class="card card-body mb-0">

        <div class="row mb-2">
          <div class="form-group col-sm-12">
            <ul class="navbar-nav overflow-auto flex-row gap-4" >
              <li v-for="(value, tab) in Tabs" :key="tab" class="nav-item nav-item-spaced d-lg-block text-nowrap" >
                <a href="#" @click.prevent="selectTab(tab)" class="nav-link tab" :class="{'active': activeTabName === tab}">{{ helper.trans(`traders.tab.${tab}`) }}</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="row">
          <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
            <div class="col p-0">
              <div class="">
                <input type="text" class="form-control form-control-sm" @keydown.enter="() => applyFilters()" :placeholder="helper.trans('labels.name')" v-model="requestDTO.query">
              </div>
            </div>
          </div>

          <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" v-if="isAdmin || isOperator || isTeamLead">
            <div class="col p-0">
              <div class="">
                <TeamLeadMultiselect :multiple="true" v-model="teamLeadsFilter"></TeamLeadMultiselect>
              </div>
            </div>
          </div>

          <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2"  v-if="isAdmin || isOperator">
            <div class="col p-0">
              <div class="">
                <TrafficGroupMultiselect :multiple="true" small v-model="trafficGroupsFilter">
                </TrafficGroupMultiselect>
              </div>
            </div>
          </div>

          <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" v-if="(isAdmin || isOperator || isTeamLead) && activeTabName !== 'all'">
            <div class="col p-0">
              <div class="">
                <Multiselect id="blockReasons"
                             class="multiselect-sm"
                             v-model="requestDTO.blockReasons"
                             :options="Object.values(BlockReason)"
                             :custom-label="(opt) => helper.trans(`block_reason.${opt}`)"
                             :multiple="true"
                             select-label="Select"
                             :placeholder="helper.trans('block_reason.label')"
                >
                </Multiselect>
              </div>
            </div>
          </div>

          <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" v-if="(isAdmin || isOperator || isTeamLead) && activeTabName === 'all'">
            <div class="col p-0">
              <div class="">
                <Multiselect id="blockReasons"
                             class="multiselect-sm"
                             v-model="requestDTO.excludedBlockReasons"
                             :options="Object.values(BlockReason)"
                             :custom-label="(opt) => helper.trans(`block_reason.${opt}`)"
                             :multiple="true"
                             select-label="Select"
                             :placeholder="helper.trans('labels.excluded_block_reason')"
                >
                </Multiselect>
              </div>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" v-if="isAdmin || isOperator || isTeamLead">
            <div class="col p-0">
              <div class="">
                <input type="text" class="form-control form-control-sm"
                       :placeholder="helper.trans('labels.from_sum_balance')" v-model="requestDTO.minBalanceAmount">
              </div>
            </div>
          </div>

          <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" v-if="isAdmin || isOperator || isTeamLead">
            <div class="col p-0">
              <div class="">
                <input type="text" class="form-control form-control-sm"
                       :placeholder="helper.trans('labels.to_sum_balance')" v-model="requestDTO.maxBalanceAmount">
              </div>
            </div>
          </div>
          <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" v-if="isAdmin || isOperator || isTeamLead">
            <div class="col p-0">
              <div class="">
                <select class="form-select form-select-sm" v-model="requestDTO.hasRequisitesPlan">
                  <option value="" disabled selected>{{ helper.trans('filters.plan_status.placeholder') }}</option>
                  <option value="active">{{ helper.trans('filters.plan_status.enabled') }}</option>
                  <option value="inactive">{{ helper.trans('filters.plan_status.disabled') }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2 d-flex align-items-center" v-if="(isAdmin || isOperator || isTeamLead) && activeTabName === 'active'">
            <div class="col p-0">
              <ul class="navbar-nav overflow-auto flex-row gap-2">
                <li class="nav-item nav-item-spaced d-lg-block text-nowrap">
                  <a href="#" @click.prevent="requestDTO.activeType = 'in'; loadList()" :class="{'active': requestDTO.activeType === 'in'}" class="nav-link tab">{{helper.trans('labels.pay_in')}}</a>
                </li>
                <li class="nav-item nav-item-spaced d-lg-block text-nowrap">
                  <a href="#" @click.prevent="requestDTO.activeType = 'out';loadList()" :class="{'active': requestDTO.activeType === 'out'}" class="nav-link tab">{{helper.trans('labels.pay_out')}}</a>
                </li>
                <li class="nav-item nav-item-spaced d-lg-block text-nowrap">
                  <a href="#" @click.prevent="requestDTO.activeType = null; loadList()" :class="{'active': requestDTO.activeType === null}"  class="nav-link tab text-capitalize">{{helper.trans('labels.all')}}</a>
                </li>
              </ul>
            </div>
          </div>

          <div class="form-group mb-2 col">
            <div class="col-auto p-0 text-end ">
              <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
              <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-12">
      <div class="card card-body">
        <div class="row" v-if="isTeamLead">
          <div class="col-sm-12">
            <button type="button" @click.prevent="downloadTradersRate(user?.id)" class="btn btn-link btn-sm m-0 p-0 text-capitalize-first float-end">
              <i class="fa fa-file-export"></i> {{ helper.trans('labels.download_traders_percent_rates')}}
            </button>
          </div>
          <div class="col-sm-12">
            <button type="button" @click.prevent="ratesImportModal = true; importFile = null" class="btn btn-link btn-sm m-0 p-0 text-capitalize-first float-end">
              <i class="fa fa-file-import"></i> {{ helper.trans('labels.import_traders_percent_rates')}}
            </button>
          </div>
        </div>

        <div class="overflow-auto">
          <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
            <thead>
            <tr>
              <td></td>
              <th class="text-capitalize-first" style="width: 0" >{{ helper.trans('direction.in') }}</th>
              <th class="text-capitalize-first" style="width: 0">{{ helper.trans('direction.out') }}</th>
              <th  v-if="isAdmin || isOperator || isTeamLead" class="text-capitalize-first">
                {{ helper.trans('labels.id') }}
                <a href="#" @click.prevent="helper.toggleOrderBy(orderByDTO, 'id'); loadList()">
                  <i class="fa-solid"  :class="helper.orderByClass(orderByDTO, 'id')" ></i>
                </a>
              </th>
              <th class="text-capitalize-first">{{ helper.trans('labels.name') }}</th>
              <th  v-if="isAdmin || isOperator" class="text-capitalize-first">{{ helper.trans('labels.teamlead') }}</th>
              <th class="text-capitalize-first">
                {{ helper.trans('labels.balances') }}
                <a v-if="isAdmin || isOperator || isTeamLead" href="#" @click.prevent="helper.toggleOrderBy(orderByDTO, 'balance'); loadList()">
                  <i class="fa-solid"  :class="helper.orderByClass(orderByDTO, 'balance')" ></i>
                </a>
              </th>
              <th class="text-end">
                <button v-if="isAdmin" type="button" v-on:click="showEditModal({})" class="btn btn-outline-primary btn-sm text-capitalize">{{ helper.trans('button.create') }}</button>
                <b-modal v-if="isAdmin || isOperator" dialog-class="modal-lg"
                         :title="createModalTitle"
                         :modelValue="createModal"
                         body-class="pt-0"
                         @update:modelValue="createModal = $event"
                >
                  <template #default>
                    <TraderForm ref="createForm" @updated="onTraderUpdated"></TraderForm>
                  </template>
                  <template #footer>
                    <button type="button" v-on:click="createModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
                    <LoaderWrapper ref="loaderCreateFrom" :zoom="0.5">
                      <button type="button" @click="save()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans('button.save') }}</button>
                    </LoaderWrapper>
                  </template>
                </b-modal>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="trader in response.items" :key="trader.id" class="">
              <td class="text-center">
                <i v-b-tooltip.hover :title="helper.trans('labels.user_blocked')" v-if="trader.isBlocked" class="fa fa-ban text-danger"></i>
                <div v-else class="d-flex flex-column">
                  <small class="form-switch" v-b-tooltip.hover.left :title="`${helper.trans('direction.in')}: ${helper.trans(trader.isActive ? 'trader.status.active' : 'trader.status.inactive')}`">
                    <input id="traderStatus" :disabled="isTeamLead && !store.getters.hasPermission(UserPermission.MANAGE_TRADER_TRAFFIC)" @click.prevent="toggleStatus(trader, !trader.isActive, Direction.PAY_IN)" class="form-check-input" style="cursor: pointer" type="checkbox" role="switch" :checked="trader.isActive">
                  </small>
                  <small class="form-switch" v-b-tooltip.hover.left :title="`${helper.trans('direction.out')}: ${helper.trans(trader.isPayOutActive ? 'trader.status.active' : 'trader.status.inactive')}`">
                    <input id="traderStatus" :disabled="isTeamLead && !store.getters.hasPermission(UserPermission.MANAGE_TRADER_TRAFFIC)" @click.prevent="toggleStatus(trader, !trader.isPayOutActive, Direction.PAY_OUT)" class="form-check-input" style="cursor: pointer" type="checkbox" role="switch" :checked="trader.isPayOutActive">
                  </small>
                </div>
              </td>
              <td class="text-center">
                <div v-if="(isAdmin || isOperator)" class="d-inline-block">
                  <button :disabled="trader.isBlocked" v-if="!trader.isPayInTrafficBlocked" v-b-tooltip.hover :title="helper.trans('trader.status.active')" @click.prevent="toggleTraffic(trader, Direction.PAY_IN, false)" class="ms-2 btn-sm btn btn-outline-success"><i class="fa fa-circle-play"></i></button>
                  <button :disabled="trader.isBlocked" v-else v-b-tooltip.hover :title="helper.trans('labels.traffic_blocked')" @click.prevent="toggleTraffic(trader, Direction.PAY_IN, true)" class="ms-2 btn btn-sm btn-outline-warning"><i class="fa fa-circle-pause"></i></button>
                </div>
                <div v-else class="d-inline-block">
                  <i v-if="trader.isPayInTrafficBlocked" v-b-tooltip.hover :title="helper.trans('labels.traffic_blocked')" class="fa fa-circle-pause text-warning"></i>
                  <i v-else v-b-tooltip.hover :title="helper.trans('trader.status.active')" class="fa fa-circle-play text-success"></i>
                </div>
              </td>
              <td class="text-center">
                <div v-if="(isAdmin || isOperator)" class="d-inline-block">
                  <button :disabled="trader.isBlocked" v-if="!trader.isPayOutTrafficBlocked" v-b-tooltip.hover :title="helper.trans('trader.status.active')" @click.prevent="toggleTraffic(trader, Direction.PAY_OUT, false)" class="ms-2 btn btn-sm btn-outline-success"><i class="fa fa-circle-play"></i></button>
                  <button :disabled="trader.isBlocked" v-else v-b-tooltip.hover :title="helper.trans('labels.traffic_blocked')" @click.prevent="toggleTraffic(trader, Direction.PAY_OUT, true)" class="ms-2 btn btn-sm btn-outline-warning"><i class="fa fa-circle-pause"></i></button>
                </div>
                <div v-else class="d-inline-block">
                  <i v-if="trader.isPayOutTrafficBlocked" v-b-tooltip.hover :title="helper.trans('labels.traffic_blocked')" class="fa fa-circle-pause text-warning"></i>
                  <i v-else v-b-tooltip.hover :title="helper.trans('trader.status.active')" class="fa fa-circle-play text-success"></i>
                </div>
              </td>
              <td  v-if="isAdmin || isOperator || isTeamLead">{{ trader.id }}</td>
              <td>
                <div class="d-flex flex-column">
                  <UserNameLabel :user="trader"></UserNameLabel>
                </div>
                <small v-if="isAdmin && trader.blockReason" class="text-danger">
                  <i class="fa fa-warning"></i> {{helper.trans(`block_reason.${trader.blockReason}`)}}
                </small>
                <div v-if="(isAdmin || isOperator) && trader.isAlfaCardsEnabled">
                  <small class="text-primary">
                    <i class="fa fa-info-circle"></i> {{ helper.trans("labels.is_alfa_cards_enabled") }}
                  </small>
                </div>
                <div v-if="deviceSumCheckDisablingEnabled && (isAdmin || isOperator) && trader.isDeviceSumCheckDisabled">
                  <small class="text-primary">
                    <i class="fa fa-info-circle"></i> {{ helper.trans("labels.is_device_sum_check_disabled") }}
                  </small>
                </div>
                <div v-if="(isAdmin || isOperator) && trader.comment">
                  <small class="text-secondary" style="white-space: normal;">
                    <i class="fa fa-comment"></i> {{ trader.comment }}
                  </small>
                </div>
              </td>
              <td  v-if="isAdmin || isOperator">
                <template  v-for="(teamLead, index) in trader.teamLeads" :key="index">
                  <div class="d-flex mb-1 align-items-center" v-if="teamLead">
                    <UserNameLabel :user="teamLead"></UserNameLabel> <i v-if="trader.hiddenTeamLeads.includes(teamLead?.id)" class="fa fa-eye-slash ms-2"></i>
                  </div>
                </template>

              </td>
              <td>
                <div v-for="account in trader._accounts">

                  <div class="row">
                    <div class="col-sm-12 d-flex align-items-center justify-content-between">
                      <AccountWidget :account="account"></AccountWidget>
                      <div class="d-flex align-items-center">
                        <div v-if="isAdmin || isOperator" class="me-2 text-secondary">
                          <small v-b-tooltip.hover :title="account.id">{{ account.id.substring(0, 8) }}</small> <copy-button :value="account.id"></copy-button>
                        </div>
                        <button v-if="isAdmin || isOperator" @click="$refs.accountOperationsModal.showModal(account)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize-first">
                          {{ helper.trans("menu.items.accountOperations") }}
                        </button>
                        <button v-if="isAdmin || isOperator" type="button" @click="showAccountWalletModal(account)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize ms-2"><i class="fa fa-wallet"></i></button>
                      </div>
                    </div>
                  </div>

                </div>
              </td>
              <td class="text-end">
                <div class="btn-group" v-if="isAdmin">
                  <button type="button" @click="showEditModal(trader)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize"><i class="fa fa-pencil"></i> {{helper.trans('button.edit')}}</button>
                  <button type="button" class="btn btn-sm btn-outline-dark dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" v-bs-dropdown-fixed aria-expanded="false">
                    <span class="visually-hidden">Toggle Dropdown</span>
                  </button>
                  <ul class="dropdown-menu">
                    <li v-if="!trader.isBlocked">
                      <a class="dropdown-item" href="#" @click.prevent="showBlockReason(trader)"><i class="fa fa-ban"></i> {{helper.trans('button.block')}}</a>
                    </li>
                    <li v-else>
                      <a class="dropdown-item" :class="{disabled: !store.getters.hasPermission(UserPermission.UNBLOCK_TRADERS)}" href="#" @click.prevent="unblockTrader(trader)"><i class="fa-regular fa-circle-check"></i> {{helper.trans('button.unblock')}}</a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="#" @click.prevent="showPayoutSettings(trader.id)"><i class="fa fa-gear"></i> {{helper.trans('button.payout_settings')}}</a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="#" @click.prevent="showTraderHistory(trader)"><i class="fa fa-clock-rotate-left"></i> {{helper.trans('labels.history')}}</a>
                    </li>
                    <li v-if="store.getters.hasPermission(UserPermission.VIEW_USER_SESSION_HISTORY)">
                      <a class="dropdown-item" href="#" @click.prevent="downloadSessionHistory(trader.id)"><i class="fa fa-file-download"></i> {{helper.trans('button.download_session_history')}}</a>
                    </li>
                  </ul>
                </div>
                <div class="btn-group" v-if="isOperator">
                  <button v-if="store.getters.hasPermission(UserPermission.BLOCK_TRADERS) && !trader.isBlocked" type="button" @click="showBlockReason(trader)"  class="btn btn-sm btn-outline-dark text-nowrap text-capitalize"><i class="fa fa-ban"></i> {{helper.trans('button.block')}}</button>
                  <button type="button" @click.prevent="showTraderHistory(trader)" class="ms-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize">
                    <i class="fa fa-clock-rotate-left"></i> {{helper.trans('labels.history')}}
                  </button>
                  <button v-if="store.getters.hasPermission(UserPermission.RESET_TRADER_PASSWORD)" type="button" @click.prevent="showChangePasswordModal(trader)" class="ms-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize">
                    <i class="fa fa-key"></i> {{helper.trans('button.change_password')}}
                  </button>
                </div>
                <button v-if="(isAdmin || isTeamLead) || (isOperator && !store.getters.hasPermission(UserPermission.HIDE_DEAL_RATES))" type="button" @click="showRouting(trader)" class="ms-2 btn btn-sm btn-outline-dark text-nowrap text-capitalize">
                  <i class="fa fa-percent"></i> {{helper.trans('labels.percent_rates')}}
                  <i class="fa fa-eye" v-if="isTeamLead && trader.mainTeamLead?.id !== user?.id"></i>
                  <i class="fa fa-pencil" v-if="isTeamLead && trader.mainTeamLead?.id === user?.id"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>

          <b-pagination
            v-if="response.totalCount > response.items.length"
            v-model="page"
            :total-rows="response.totalCount"
            :per-page="response.limit"
            :limit="20"
            @update:modelValue="loadList()"
            prev-text="Back"
            next-text="Next"
            align="start"
            first-number
            hide-goto-end-buttons
            hide-ellipsis
          ></b-pagination>

        </div>
      </div>
    </div>
    <InviteLinkConfirmModal ref="inviteLinkConfirmModal"></InviteLinkConfirmModal>

    

    <b-modal :title="helper.trans('labels.transfer')" :modelValue="transferAccount !== null" header-class="text-capitalize" body-class="pt-0" footer-class="d-flex justify-content-between" @update:modelValue="$event === false && (transferAccount = null)">
      <template #default>
        <TransferForm ref="transferForm" :account="transferAccount"></TransferForm>
      </template>
      <template #footer>
        <button type="button" v-on:click="transferAccount = null" class="btn btn-outline-dark btn-sm text-capitalize-first">{{ helper.trans("button.cancel") }}</button>
        <LoaderWrapper ref="loaderTransferForm" :zoom="0.5">
          <button type="button" v-on:click="createTransfer()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans("button.transfer") }}</button>
        </LoaderWrapper>
      </template>
    </b-modal>

    <b-modal :title="helper.trans('labels.import_traders_percent_rates')" :modelValue="ratesImportModal !== null" header-class="text-capitalize" body-class="pt-0" footer-class="d-flex justify-content-between" @update:modelValue="$event === false && (ratesImportModal = null)">
      <template #default>

        <div class="row mb-3 mt-3">
          <div class="col-sm-12">
            <div style="cursor: pointer; border:1px dashed" v-bind="dropzone.getRootProps()" class="payout-dropzone rounded border-secondary p-3 pt-4 pb-4 d-flex justify-content-center align-items-center">
              <input v-bind="dropzone.getInputProps()" />
              <p class="p-0 m-0">{{ helper.trans('labels.payout_upload_files')}}</p>
            </div>
          </div>
        </div>

        <div v-if="importFile">
          <div class="col-sm-12">
            <i class="fa fa-paperclip"></i> <span class="me-2">{{ importFile.name}}</span>
            <a href="#" @click.prevent="importFile = null">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>

      </template>
      <template #footer>
        <button type="button" v-on:click="ratesImportModal = null" class="btn btn-outline-dark btn-sm text-capitalize-first">{{ helper.trans("button.cancel") }}</button>

        <LoaderWrapper ref="loaderRatesImportModal" :zoom="0.5">
          <button type="button" v-on:click="importTraderRates(user?.id)" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans("labels.import") }}</button>
        </LoaderWrapper>
      </template>
    </b-modal>

    <b-modal dialog-class="modal-xxl"
             :title="`${routingTrader?.name}`"
             :modelValue="routingTrader !== null"
             body-class="pt-0"
             @update:modelValue="$event === false && (routingTrader = null)"
    >
      <template #default>
        <TraderRewardSettingsForm ref="traderRewardSettingsForm" :trader="routingTrader"></TraderRewardSettingsForm>
      </template>
      <template #footer>
        <button type="button" v-on:click="routingTrader = null" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
        <LoaderWrapper ref="loaderRoutingRule" :zoom="0.5" v-if="isAdmin || isOperator || (isTeamLead && routingTrader?.mainTeamLead?.id === user?.id)">
          <button type="button" @click="saveRoutingRule()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans('button.save') }}</button>
        </LoaderWrapper>
      </template>
    </b-modal>

    <b-modal
        :title="`${blockingTrader?.name}`"
        :modelValue="blockingTrader !== null"
        header-class="text-capitalize"
        body-class="pt-0"
        footer-class="d-flex justify-content-between"
        @update:modelValue="$event === false && (blockingTrader = null)"
    >
      <template #default>
        <Multiselect
          class="mt-3"
                     v-model="blockReason"
                     :options="Object.values(BlockReason)"
                     :custom-label="(opt) => helper.trans(`block_reason.${opt}`)"
                     select-label="Select"
                     :placeholder="helper.trans('block_reason.label')"
                     open-direction="bottom"
                     :multiple="false"
                     :searchable="false"
                     :close-on-select="true"
                     :show-no-results="false"
        >
        </Multiselect>
      </template>
      <template #footer>
        <button
            type="button"
            v-on:click="blockingTrader = null; blockReason = null"
            class="btn btn-outline-dark btn-sm text-capitalize-first"
        >
          {{ helper.trans("button.cancel") }}
        </button>

        <LoaderWrapper ref="loaderBlockReasonModal" :zoom="0.5">
          <button
              type="button"
              v-on:click="saveBlockReason()"
              :disabled="!blockReason"
              class="btn btn-outline-primary btn-sm text-capitalize-first"
          >
            {{ helper.trans('button.block') }}
          </button>
        </LoaderWrapper>
      </template>
    </b-modal>

    <b-modal title=""
             dialog-class="modal-lg"
             :modelValue="payOutSettingsModal"
             footer-class="d-flex justify-content-end"
             @update:modelValue="payOutSettingsModal = $event">
      <template #default>
        <LoaderWrapper ref="payOutSettingsModalLoader">
          <div class="row mb-2">
            <div class="col-sm-12">
              <div class="row mt-2">
                <label for="from_sum" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.from_sum") }}</label>
                <div class="col-sm-8">
                  <FormInputWrapper v-slot="parentProps" :errors="getErrors(`minAmount`)">
                    <input :class="parentProps.class" v-model="payOutSettings.minAmount" type="text" class="form-control " id="from_sum" :readonly="!isAdmin">
                  </FormInputWrapper>
                </div>
              </div>

              <div class="row mt-2">
                <label for="to_sum" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.to_sum") }}</label>
                <div class="col-sm-8">
                  <FormInputWrapper v-slot="parentProps" :errors="getErrors(`maxAmount`)">
                    <input v-model="payOutSettings.maxAmount" :class="parentProps.class"  type="text" class="form-control " id="to_sum" :readonly="!isAdmin">
                  </FormInputWrapper>
                </div>
              </div>

              <div class="row mt-2">
                  <label for="pay-out-currencies" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.currencies") }}</label>
                  <div class="col-sm-8">
                    <FormInputWrapper v-slot="parentProps" :errors="getErrors(`appId`)">
                      <Multiselect id="pay-out-currencies"
                                   class="multiselect-sm"
                                   v-model="payOutSettings.currencies"
                                   :options="currencyList"
                                   :custom-label="(opt) => `${opt}`"
                                   :multiple="true"
                                   select-label="Select"
                                   :disabled="!isAdmin"
                      >
                      </Multiselect>
                    </FormInputWrapper>
                  </div>
                </div>

              <div class="row mt-2">
                  <label class="col-sm-4 col-form-label text-capitalize-first" for="pay-out-roundedToTakerSum">
                    {{ helper.trans('labels.rounded_to_1000')}}
                  </label>
                <div class="col-sm-8">
                  <div class="form-check form-switch d-flex align-items-center">
                    <input class="form-check-input" :disabled="!isAdmin" v-model="payOutSettings.multiplesOfValue1000"
                           type="checkbox" id="pay-out-roundedToTakerSum">
                  </div>
                </div>
               </div>

              <div class="row mt-2">
                <label for="pay-out-methods" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payment_methods") }}</label>
                <div class="col-sm-8">
                  <FormInputWrapper v-slot="parentProps" :errors="getErrors(`payment_methods`)">
                    <Multiselect id="pay-out-methods"
                                 class="multiselect-sm"
                                 v-model="payOutSettings.paymentMethods"
                                 :options="methodList()"
                                 :custom-label="(opt) => helper.trans(`pay_methods.${opt}`)"
                                 :multiple="true"
                                 select-label="Select"
                                 :disabled="!isAdmin"
                    >
                      <template #option="props">
                        <div class="d-flex flex-row align-items-center gap-2">
                          <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                          <span class="overflow-hidden" style="white-space: nowrap; text-overflow: ellipsis">{{ helper.trans('pay_methods.' + props.option) }}</span>
                        </div>
                      </template>
                    </Multiselect>
                  </FormInputWrapper>
                </div>
              </div>

              <div class="row mt-2">
                <label for="pay-out-options" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payment_options") }}</label>
                <div class="col-sm-8">
                  <FormInputWrapper v-slot="parentProps" :errors="getErrors(`payment_options`)">
                    <Multiselect id="pay-out-options"
                                 class="multiselect-sm"
                                 v-model="payOutSettings.paymentOptions"
                                 :options="store.getters['currencyMethods/options']()"
                                 :custom-label="(opt) => helper.trans(`payment_options.${opt}`)"
                                 :multiple="true"
                                 select-label="Select"
                                 :disabled="!isAdmin"
                    >
                    </Multiselect>
                  </FormInputWrapper>
                </div>
              </div>

              <div class="row mt-2">
                <label for="pay-out-onlyMir" class="col-sm-4 col-form-label text-capitalize-first">
                  {{ helper.trans("labels.only_mir_cards") }}
                </label>
                <div class="col-sm-8">
                  <div class="form-check form-switch d-flex align-items-center">
                    <input class="form-check-input" v-model="payOutSettings.onlyMir" :true-value="true"  type="checkbox" value="" id="pay-out-onlyMir" :disabled="!isAdmin">
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <label for="maxActiveDealCount" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.max_active_deals_count") }}</label>
                <div class="col-sm-8">
                  <div class="col-sm-8">
                    <input type="text" class="form-control form-control-sm" v-model="payOutSettings.maxActiveDealsCount" :readonly="!isAdmin" id="maxActiveDealCount">
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <label for="limitAmount" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.limitAmount") }}</label>
                <div class="col-sm-8">
                  <div class="col-sm-8">
                    <input type="text" class="form-control form-control-sm" v-model="payOutSettings.limitAmount" :readonly="!isAdmin" id="limitAmount">
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <label for="limitIntervalMinutes" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.limitIntervalMinutes") }}</label>
                <div class="col-sm-8">
                  <div class="col-sm-8">
                    <input type="text" class="form-control form-control-sm" v-model="payOutSettings.limitIntervalMinutes" :readonly="!isAdmin" id="limitIntervalMinutes">
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <label class="col-sm-4 col-form-label text-capitalize-first" for="auto_accept_payouts">
                  {{ helper.trans('labels.auto_accept_payouts')}}
                </label>
                <div class="col-sm-8">
                  <div class="form-check form-switch d-flex align-items-center">
                    <input class="form-check-input" :disabled="!isAdmin" v-model="payOutSettings.autoAccept"
                           type="checkbox" id="auto_accept_payouts">
                  </div>
                </div>
              </div>

              <hr class="my-3" v-if="isAdmin || (isOperator && payOutSettings.isPayinBalanceLimitActive)">

              <PayinBalanceLimitSection
                  v-if="isAdmin"
                  :settings="payOutSettings"
                  show-admin-controls
                  :can-edit="isAdmin"
                  :can-reset="canResetPayinBalance"
                  @reset="resetPayinBalance"
              />
              <PayinBalanceLimitSection
                  v-else-if="isOperator && payOutSettings.isPayinBalanceLimitActive"
                  :settings="payOutSettings"
              />

            </div>
          </div>
        </LoaderWrapper>
      </template>
      <template #footer>
        <button  type="button" @click.prevent="payOutSettingsModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">
          {{ helper.trans('button.cancel')  }}
        </button>
        <button :disabled="!isAdmin" type="button" @click.prevent="savePayoutSettings(payOutSettings.traderId)" class="btn btn-outline-primary btn-sm text-capitalize-first">
          {{ helper.trans('button.save')  }}
        </button>
      </template>
    </b-modal>

    <AccountOperationsModal ref="accountOperationsModal"></AccountOperationsModal>
    <AccountWalletModal ref="accountWalletModal"></AccountWalletModal>
    <ConfirmModal ref="confirmModal"></ConfirmModal>
    <ChangePasswordModal ref="changePasswordModal"></ChangePasswordModal>
    <SettingsHistoryModal ref="traderHistoryModal" entity-type="trader" />
  </LoaderWrapper>
</template>

<script lang="ts">

import {computed, defineComponent, onMounted, ref} from 'vue'
import {helper} from "@/service/CommonHelper";
import {reactive, toRefs} from "@vue/reactivity";
import {api} from "@/service/APIClient";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import CopyButton from "@/components/CopyButton.vue";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import TraderDTO from "@/models/TraderDTO";
import TraderForm from "@/components/Form/TraderForm.vue";
import TraderFormDTO from "@/models/form/TraderFormDTO";
import {useNotification} from "@kyvg/vue3-notification";
import InviteLinkConfirmModal from "@/components/InviteLinkConfirmModal.vue";
import {useStore} from "vuex";
import PaginationDTO from "@/models/PaginationDTO";
import AccountDTO from "@/models/AccountDTO";
import TransferForm from "@/components/Form/TransferForm.vue";
import AccountWidget from "@/components/AccountWidget.vue";
import Multiselect from "vue-multiselect";
import {Direction} from "@/models/enum/Direction";
import {BlockReason} from "@/models/enum/BlockReason";
import UserNameLabel from "@/components/UserNameLabel.vue";
import router from "@/router";
import AccountOperationsModal from "@/components/AccountOperationsModal.vue";
import ChangePasswordModal from "@/components/ChangePasswordModal.vue";
import UserDTO from "@/models/UserDTO";
import ConfirmModal, {ConfirmModalProps} from "@/components/ConfirmModal.vue";
import PayinBalanceLimitSection from "@/components/PayinBalanceLimitSection.vue";
import TraderRewardSettingsForm from "@/components/Form/TraderRewardSettingsForm.vue";
import {useDropzone} from "vue3-dropzone";
import TeamLeadMultiselect from "@/components/TeamLeadMultiselect.vue";
import AccountWalletModal from "@/components/AccountWalletModal.vue";
import OrderByDTO from "@/models/OrderByDTO";
import {UserPermission} from "@/models/enum/UserPermission";
import TraderPayoutSettingsDTO, {defaultDto} from "@/models/TraderPayoutSettingsDTO";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import TrafficGroupMultiselect from "@/components/TrafficGroupMultiselect.vue";
import TrafficGroupDTO from "@/models/TrafficGroupDTO";
import SettingsHistoryModal from "@/components/SettingsHistoryModal.vue";

enum Tabs {
  active = 'active', inactive = 'inactive', blocked = 'blocked', all = 'all'
}

const notification = useNotification()
const defaultCreateForm = {
  id: null,
  name: null,
  email: null,
  password: '',
  isProvider: false,
  isProviderLowBalanceAlertEnabled: false,
  providerLowBalanceThreshold: null,
  isPayOutTrafficBlocked: true,
  isRequisitesReuseEnable: false,
  isPayInTrafficBlocked: true,
  isAlfaCardsEnabled: false,
  isDeviceSumCheckDisabled: false,
  isAvailable24: false,
  isManualWithdrawals: false,
  createInvite: true,
  teamLeads: [null, null, null, null, null] as null[],
  hiddenTeamLeads: [],
  mainTeamLead: null,
  insuranceLimitUSDT: '0',
  appId: null,
  is2faEnabled: false,
  tgChatGroupId: null,
  tgLowBalanceChatGroupId: null,
  isPayOutDisputeReminderToGroupChat: false,
  isConcurrentDealsLimitEnabled: false,
  concurrentDealsLimit: null,
  comment: null,
  disabledAfRules: null,
  withdrawalAddress: null,
  disputeAutoClosePeriodMinutes: null,
  nightDisputeAutoCloseHour: null,
  nightDisputeAutoCloseMinutes: null,
  isAutoCabinetBlockEnabled: false,
  autoCabinetBlockTimeoutMinutes: 1440,
  isAutoCabinetBlockPayInEnabled: true,
  isAutoCabinetBlockPayOutEnabled: true,
  payInRateSource: null,
  payOutRateSource: null,
  payInFixedRate: null,
  payOutFixedRate: null,
  isEffectiveRateEnabled: false
} as TraderFormDTO

export default defineComponent({
  components: {
    TrafficGroupMultiselect,
    FormInputWrapper,
    PayMethodIcon,
    AccountWalletModal,
    TeamLeadMultiselect,
    TraderRewardSettingsForm,
    ConfirmModal,
    PayinBalanceLimitSection,
    Multiselect,
    AccountWidget,
    LoaderWrapper,
    CopyButton,
    TraderForm,
    InviteLinkConfirmModal,
    TransferForm,
    UserNameLabel,
    AccountOperationsModal,
    SettingsHistoryModal,
    ChangePasswordModal,
  },
  props: ['type'],
  setup(props) {

    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderCreateFrom = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const createForm = ref<InstanceType<typeof TraderForm> | null>(null)
    const traderHistoryModal = ref<InstanceType<typeof SettingsHistoryModal> | null>(null)
    const inviteLinkConfirmModal = ref<InstanceType<typeof InviteLinkConfirmModal> | null>(null)
    const transferForm = ref<InstanceType<typeof TransferForm> | null>(null)
    const traderRewardSettingsForm = ref<InstanceType<typeof TraderRewardSettingsForm> | null>(null)
    const loaderTransferForm = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderRoutingRule = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderRatesImportModal = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const accountWalletModal = ref<InstanceType<typeof AccountWalletModal> | null>(null)
    const loaderBlockReasonModal = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const payOutSettingsModalLoader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const confirmModal = ref<InstanceType<typeof ConfirmModal> | null>(null)
    const changePasswordModal = ref<InstanceType<typeof ChangePasswordModal> | null>(null)

    const state = reactive({
      trafficGroupsFilter: [] as TrafficGroupDTO[],
      blockReason: null as BlockReason|null,
      importFile: null as any,
      ratesImportModal: null as boolean|null,
      blockReasonModal: null as boolean|null,
      routingVersion: 1 as number,
      activeTabName: Tabs.active,
      createModalTitle: '',
      createModal: false,
      routingTrader: null as TraderDTO|null,
      page: 1,
      transferAccount: null as AccountDTO|null,
      blockingTrader: null as TraderDTO|null,
      requestDTO: {
        query: '',
        statuses: [],
        isBlocked: null,
        blockReasons: [],
        excludedBlockReasons: [],
        activeType: null,
        minBalanceAmount: null,
        maxBalanceAmount: null,
        hasRequisitesPlan: null
      } as any,
      orderByDTO: {
        field: 'id',
        direction: 'asc'
      } as OrderByDTO,
      response: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<TraderDTO>,
      teamLeadsFilter: [] as UserDTO[],
      payOutSettingsModal: false as boolean,
      payOutSettings: {
        ...defaultDto
      } as TraderPayoutSettingsDTO,
      errors: {} as ValidationErrorDTO[]|any,
    });

    const loadList = async () => {
      loader.value?.show()
      state.response.offset = state.response.limit * (state.page - 1)
      const requestDTO = {
        ...state.requestDTO,
        refIds: state.teamLeadsFilter.map((item) => item.id),
        trafficGroupsIds: state.trafficGroupsFilter.map((value) => value.id),
        traderType: props.type === 'traders' ? 'without_provider' : 'with_provider',
        balanceType: props.type === 'traders' ? 'trader' : 'provider'
      }
      state.response = await api.traders(state.response, requestDTO, state.orderByDTO);

      let accountIds = state.response.items.map(trader => trader.id)

      let traderAccounts = {} as AccountDTO[]|any;
      for (const account of (await api.traderAccounts({offset:0, limit: 1000} as PaginationDTO, {userIds: accountIds})).items) {
        if (!traderAccounts[account.traderId]) {
          traderAccounts[account.traderId] = [];
        }
        traderAccounts[account.traderId].push(account.account)
      }

      for (const item of state.response.items) {
        item._accounts = traderAccounts[item.id] ?? []
      }

      loader.value?.hide()
    }

    const showRouting = (dto: TraderDTO) => {
      state.routingTrader = dto
    }

    const formatThresholdAmount = (amount?: string|null): string|null => {
      if (!amount) {
        return null
      }

      return amount.includes('.') ? amount.replace(/0+$/, '').replace(/\.$/, '') : amount
    }

    const showEditModal = (dto: TraderDTO) => {
      if (dto.id) {
        state.createModalTitle = helper.trans("labels.edit_trader", {name: dto.name})
        const { planStatuses, ...dtoWithoutPlanStatuses } = dto as any;
        createForm.value?.setForm({
          ...defaultCreateForm,
          isProvider: props.type !== 'traders',
          ...dtoWithoutPlanStatuses,
          insuranceLimitUSDT: dto.insuranceLimitUSDT?.amount,
          providerLowBalanceThreshold: formatThresholdAmount(dto.providerLowBalanceThresholdSum?.amount),
          payInFixedRate: dto.payInFixedRateSum?.amount,
          payOutFixedRate: dto.payOutFixedRateSum?.amount
        } as TraderFormDTO)
      } else {
        state.createModalTitle = helper.trans("labels.create_trader")
        createForm.value?.setForm({
          ...defaultCreateForm,
          isProvider: props.type !== 'traders',
          teamLeads: [null, null, null, null, null] as null[],
          hiddenTeamLeads: [],
          password: helper.generatePassword()
        } as TraderFormDTO)
      }

      state.createModal = true;
    }
    const showPayoutSettings = async (id: number) => {
      state.payOutSettingsModal = true
      payOutSettingsModalLoader.value?.show()
      try {
        state.payOutSettings = await api.traderPayoutSettingsById(id)
        state.payOutSettings.traderId = id
        state.payOutSettings.limitAmount = state.payOutSettings.limitSum?.amount ?? null
      } finally {
        payOutSettingsModalLoader.value?.hide()
      }
    }

    const downloadSessionHistory = async (id: number) => {
      loader.value?.show()

      try {
        const data = await api.export('trader_sessions', {
          traderId: id
        });

        const link = document.createElement("a");
        const url = URL.createObjectURL(new Blob([data]));
        link.href = url
        link.setAttribute('download', `trader_${id}_session_report.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      } finally {
        loader.value?.hide()
      }
    }

    const showTraderHistory = (trader: TraderDTO) => {
      traderHistoryModal.value?.show(
        trader.id,
        helper.trans('labels.history') + `: ${trader.name}`,
      )
    }

    const showChangePasswordModal = (trader: TraderDTO) => {
      changePasswordModal.value?.show(trader.id, api.tradersChangePassword)
    }

    const save = () => {
      loaderCreateFrom.value?.show()

      createForm.value!.save()
        .then((trader: TraderDTO) => {
          state.createModal = false;
          if (trader.inviteToken) {
            const url = store.getters['getInviteLink'](trader);
            inviteLinkConfirmModal.value?.show(url);
          }
          loadList();
        })
        .finally(() => {
          loaderCreateFrom.value?.hide();
        })

    }

    const saveRoutingRule = async () => {
      loaderRoutingRule.value?.show()

      try {
        await traderRewardSettingsForm.value?.save();
        state.routingTrader = null;
      } finally {
        loaderRoutingRule.value?.hide()
      }
    }

    const createTransfer = () => {
      loaderTransferForm.value?.show()
      transferForm.value?.save().then(() => {
        state.transferAccount = null;
        loaderTransferForm.value?.hide()
        loadList();
      }).catch(() => {
        loaderTransferForm.value?.hide()
      })
    }

    const toggleTraffic = async (trader: TraderDTO, direction: Direction, status: boolean) => {
      loader.value?.show()
      try {
        const traderDTO = await api.tradersToggleTraffic(trader.id, direction, status ? 'enable' : 'disable')
        for (const index in state.response.items) {
          if (state.response.items[index].id === traderDTO.id) {
            state.response.items[index] = {...state.response.items[index], ...traderDTO}
            break;
          }
        }
      } finally {
        loader.value?.hide()
      }
    }

    const onTraderUpdated = (traderDTO: TraderDTO) => {
      for (const index in state.response.items) {
        if (state.response.items[index].id === traderDTO.id) {
          state.response.items[index] = {...state.response.items[index], ...traderDTO}
          break;
        }
      }
    }

    const toggleStatus = async (trader: TraderDTO, status: boolean, direction: Direction) => {
      loader.value?.show()
      try {
        const traderDTO = await api.changeTraderStatus(trader.id, status, direction)
        for (const index in state.response.items) {
          if (state.response.items[index].id === traderDTO.id) {
            state.response.items[index] = {...state.response.items[index], ...traderDTO}
            break;
          }
        }
      } finally {
        loader.value?.hide()
      }
    }

    const showBlockReason = (dto: TraderDTO) => {
      state.blockingTrader = dto
    }

    const saveBlockReason = async () => {
      loaderBlockReasonModal.value?.show()

      try {
        if (state.blockingTrader && state.blockReason) {
          const traderDTO = await api.blockTrader(
              state.blockingTrader.id,
              !state.blockingTrader.isBlocked,
              state.blockReason
          )
          for (const index in state.response.items) {
            if (state.response.items[index].id === traderDTO.id) {
              state.response.items[index] = {...state.response.items[index], ...traderDTO}
              break;
            }
          }
        }
        state.blockingTrader = null;
        state.blockReason = null;
      } finally {
        loaderBlockReasonModal.value?.hide()
        await loadList();
      }
    }

    const unblockTrader = async (trader: TraderDTO) => {
      if (!store.getters.hasPermission(UserPermission.UNBLOCK_TRADERS)) {
        return;
      }

      loader.value?.show()

      try {
        const traderDTO = await api.blockTrader(trader.id, !trader.isBlocked, null)
        for (const index in state.response.items) {
          if (state.response.items[index].id === traderDTO.id) {
            state.response.items[index] = {...state.response.items[index], ...traderDTO}
            break;
          }
        }
      } finally {
        loader.value?.hide()
      }
    }

    const applyFilters = async () => {
      state.page = 1;
      loadList()
    }

    const clearFilters = async () => {
      state.page = 1;
      state.requestDTO = {
        statuses: [],
        query: '',
        refIds: [],
        isBlocked: null,
        activeType: null
      }
      state.trafficGroupsFilter = []
      state.teamLeadsFilter = []
      selectTab(Tabs.active)
    }

    const selectTab = (tab: Tabs) => {
      state.activeTabName = tab
      state.page = 1;

      switch (tab) {
        case Tabs.active:
          state.requestDTO.statuses = [1]
          state.requestDTO.isBlocked = false
          state.requestDTO.blockReasons = []
          state.requestDTO.excludedBlockReasons = []
          state.requestDTO.activeType = null
          state.requestDTO.minBalanceAmount = null
          state.requestDTO.maxBalanceAmount = null
          break;
        case Tabs.inactive:
          state.requestDTO.statuses = [0]
          state.requestDTO.isBlocked = false
          state.requestDTO.blockReasons = []
          state.requestDTO.excludedBlockReasons = []
          state.requestDTO.activeType = null
          state.requestDTO.minBalanceAmount = null
          state.requestDTO.maxBalanceAmount = null
          break
        case Tabs.blocked:
          state.requestDTO.statuses = []
          state.requestDTO.isBlocked = true
          state.requestDTO.blockReasons = []
          state.requestDTO.excludedBlockReasons = []
          state.requestDTO.activeType = null
          state.requestDTO.minBalanceAmount = null
          state.requestDTO.maxBalanceAmount = null
          break;
        case Tabs.all:
          state.requestDTO.statuses = []
          state.requestDTO.isBlocked = null
          state.requestDTO.blockReasons = []
          state.requestDTO.excludedBlockReasons = []
          state.requestDTO.activeType = null
          state.requestDTO.minBalanceAmount = null
          state.requestDTO.maxBalanceAmount = null
          break;
      }

      loadList()
    }

    const downloadTradersRate = async (teamleadId: number) => {
      loader.value?.show()

      try {
        const data = await api.call.traderRewardSettings.exportByTeamLead(teamleadId);
        const link = document.createElement("a");
        const url = URL.createObjectURL(new Blob([data]));
        link.href = url
        link.setAttribute('download', 'percent_rates.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      } finally {
        loader.value?.hide()
      }
    }

    const importTraderRates = async (teamleadId: number) => {
      loaderRatesImportModal.value?.show()
      try {
        await api.call.traderRewardSettings.importByTeamLead(teamleadId, state.importFile)
        notification.notify({title: helper.trans('labels.traders_percent_rates_updated')});
        state.ratesImportModal = null;
      } catch (e) {
        notification.notify({type: 'error', title: helper.trans(`server_errors.INTERNAL_ERROR`)});
      } finally {
        loaderRatesImportModal.value?.hide()
      }
    }

    const showAccountWalletModal = (account: AccountDTO) => {
      accountWalletModal.value?.show(account)
    }

    const onDrop = async (acceptFiles: any, rejectReasons: any) => {
      for (const file of acceptFiles) {
        state.importFile = file
      }
    }

    const dropzone = useDropzone({ onDrop, accept:['.xlsx'], maxFiles: 1 });

    onMounted(async () => {
      store.dispatch('rateSources/loadList')
      selectTab(Tabs.active)
    });

    const savePayoutSettings = async (traderId: number) => {
      payOutSettingsModalLoader.value?.show()
      try {
        state.payOutSettings = await api.traderPayoutSettingsUpdateById(traderId, state.payOutSettings)

      } finally {
        payOutSettingsModalLoader.value?.hide()
      }
      state.payOutSettingsModal = false
    }

    const canResetPayinBalance = computed(() => store.getters.hasPermission(UserPermission.EDIT_SETTINGS));

    const resetPayinBalance = async (currency: string) => {
      const traderId = state.payOutSettings.traderId;
      if (!traderId) {
        return;
      }

      payOutSettingsModalLoader.value?.show()
      try {
        state.payOutSettings = await api.traderPayoutSettingsResetBalance(traderId, currency)
      } catch {
        notification.notify({
          title: helper.trans('labels.reset_payin_balance_limit_failed', { currency }),
          type: 'error',
        });
      } finally {
        payOutSettingsModalLoader.value?.hide()
      }
    }

    const getErrors = (path: string) => {
      if (!state.errors.hasOwnProperty(path)) {
        return [];
      }

      return state.errors[path]
    }

    return {
      ...toRefs(state),
      applyFilters,
      clearFilters,
      store,
      loader,
      loaderCreateFrom,
      loaderRoutingRule,
      dateHelper,
      numberFormatter,
      helper,
      loadList,
      save,
      showEditModal,
      showRouting,
      createForm,
      inviteLinkConfirmModal,
      isOperator: computed(() => store.getters.isOperator),
      deviceSumCheckDisablingEnabled: computed(() => !!store.getters.getAppData?.DEVICE_SUM_CHECK_DISABLING_ENABLED),
      isAdmin: computed(() => store.getters.isAdmin),
      isTeamLead: computed(() => store.getters.isTeamLead),
      user: computed(() => store.getters.getUser),
      currencyList: computed(() => store.getters["currencyMethods/currencies"]),
      methodList: computed(() => store.getters["currencyMethods/methods"]),
      createTransfer,
      saveRoutingRule,
      transferForm,
      loaderTransferForm,
      toggleTraffic,
      onTraderUpdated,
      toggleStatus,
      Direction,
      BlockReason,
      saveBlockReason,
      showBlockReason,
      unblockTrader,
      router,
      Tabs,
      selectTab,
      traderRewardSettingsForm,
      downloadTradersRate,
      loaderRatesImportModal,
      dropzone,
      importTraderRates,
      accountWalletModal,
      showAccountWalletModal,
      loaderBlockReasonModal,
      UserPermission,
      showPayoutSettings,
      savePayoutSettings,
      resetPayinBalance,
      canResetPayinBalance,
      confirmModal,
      getErrors,
      downloadSessionHistory,
      showTraderHistory,
      traderHistoryModal,
      changePasswordModal,
      showChangePasswordModal,
    }
  }
})
</script>
